import { defineStore } from 'pinia';
import { ref } from 'vue';

const useFeatureFlagStore = defineStore('featureFlag', () => {
  const flagsData = ref(null);
  const error = ref(null);
  const isLoadingFlagsData = ref(false);

  const setFlagsData = (data, error) => {
    flagsData.value = data;
    error.value = error;
  };

  return { isLoadingFlagsData, flagsData, error, setFlagsData };
});

export default useFeatureFlagStore;
